module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "details"
    }
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("City")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleMaintenance.cityId),
      expression: "vehicleMaintenance.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": _vm.isCityDisable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleMaintenance, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.getCityId($event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.citys), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id
      }
    }, [_vm._v(_vm._s(cityId.name) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Vehicle")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleMaintenance.vehicleId),
      expression: "vehicleMaintenance.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "vehicleId"
    },
    on: {
      "input": function($event) {
        _vm.vehicleCheck()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleMaintenance, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicles), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item &&
          _vm.vehicleMaintenance.vehicleId &&
          item.id === _vm.vehicleMaintenance.vehicleId
      }
    }, [_vm._v("\n                      " + _vm._s(item.name) + "\n                    ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.maintenanceDate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', {
    attrs: {
      "for": "maintenanceDate"
    }
  }, [_vm._v("Maintenance Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "required": "",
      "id": "maintenanceDate",
      "lang": "en",
      "name": "maintenanceDate",
      "input-class": "form-control",
      "width": "100%",
      "use-utc": "true",
      "format": "DD-MM-YYYY"
    },
    on: {
      "change": function($event) {
        _vm.maintenanceDate()
      }
    },
    model: {
      value: (_vm.vehicleMaintenance.maintenanceDate),
      callback: function($$v) {
        _vm.$set(_vm.vehicleMaintenance, "maintenanceDate", $$v)
      },
      expression: "vehicleMaintenance.maintenanceDate"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "maintenanceDate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Maintenance date is a required field\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Driver Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleMaintenance.driverName),
      expression: "vehicleMaintenance.driverName"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "driverName"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleMaintenance, "driverName", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.driverChangeHandler]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Driver Name")]), _vm._v(" "), _vm._l((_vm.Staff), function(driver) {
    return _c('option', {
      domProps: {
        "value": driver._id
      }
    }, [_vm._v(_vm._s(driver.firstName + " " + driver.lastName))])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver name is required field")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.amount),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleMaintenance.amount),
      expression: "vehicleMaintenance.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "10",
      "type": "text",
      "name": "amount",
      "required": "",
      "min": "0",
      "placeholder": "Amount",
      "pattern": "\\d{0,10}"
    },
    domProps: {
      "value": (_vm.vehicleMaintenance.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.vehicleMaintenance, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "amount",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Amount is a required field\n                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                      Numbers are allowed.\n                    ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.receipt),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Receipt")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "fileName",
      "accept": "image/png,image/jpeg,image/jpg,application/pdf",
      "name": "receipt"
    },
    on: {
      "change": _vm.onDocumentchanged
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "receipt",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "receipt"
    },
    slot: "receipt"
  }, [_vm._v("\n                      Receipt is required ,Please upload less than 5mb file.\n                    ")])]), _vm._v(" "), (
    _vm.$route.params &&
    _vm.$route.params._id != '0' &&
    _vm.vehicleMaintenance.receipt
  ) ? _c('div', {
    staticClass: "border p-2 mt-3"
  }, [_c('a', {
    attrs: {
      "href": _vm.vehicleMaintenance.receipt,
      "target": "_blank"
    }
  }, [_vm._v("View")])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.maintenanceType),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Maintenance Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleMaintenance.maintenanceType),
      expression: "vehicleMaintenance.maintenanceType"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "maintenanceType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.vehicleMaintenance, "maintenanceType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Maintenance Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Regular Service"
    }
  }, [_vm._v("Regular Service")])]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "maintenanceType",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                      Maintenance Type is required field\n                    ")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'vehicleMaintenance'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                Cancel\n              ")])]), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && this.docs)
    },
    on: {
      "click": _vm.createVehicleMaintenance
    }
  }, [_vm._v("\n              Save\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "btn gradientbt mr-5",
    attrs: {
      "type": "submit",
      "disabled": !((_vm.formstate.$dirty || _vm.isFileChange) && (_vm.formstate.$valid || _vm.isFileChange || _vm.isDriverChange || _vm.isVehicleEnable || _vm.isMaintenanceEnable))
    },
    on: {
      "click": _vm.updateVehicleMaintenance
    }
  }, [_vm._v("\n              Update\n            ")]) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04dd2dbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04dd2dbc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/vehiclemaintenance/vehicleMaintenanceCreate.vue
// module id = 2247
// module chunks = 0